import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import TopNav from "../components/TopNav";
import AuthPage from "./AuthPage";
import { useNavigate } from "react-router-dom";
import "../App.css";

function Applied() {
  const [user, setUser] = useState(null);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppliedJobs = async (uid) => {
      const appliedRef = collection(db, `users/${uid}/applicated`);
      const appliedSnap = await getDocs(appliedRef);
      const appliedList = [];

      for (const docSnap of appliedSnap.docs) {
        const appliedData = docSnap.data();
        const jobId = appliedData.jobId;

        const jobRef = doc(db, "items", jobId);
        const jobSnap = await getDoc(jobRef);

        if (jobSnap.exists()) {
          const jobData = jobSnap.data();
          appliedList.push({
            id: jobId,
            appliedAt: appliedData.appliedAt?.toDate()?.toLocaleDateString() || "-",
            ...jobData
          });
        }
      }

      setAppliedJobs(appliedList);
    };

    const unsub = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        fetchAppliedJobs(currentUser.uid);
      }
    });

    return () => unsub();
  }, []);

  if (!user) return <AuthPage />;

  return (
    <div className="auth-container">
      <TopNav />
      <div className="applied-section">
        <h2>Applied Jobs</h2>
        {appliedJobs.length === 0 ? (
          <p>No applied jobs found.</p>
        ) : (
          <ul className="job-list">
            {appliedJobs.map((job) => (
              <li
                key={job.id}
                className="job-tile"
                onClick={() => navigate(`/item/${job.id}`)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={job.image || "/no_image.png"}
                  alt="Job"
                  className="job-image"
                />
                <div className="job-info">
                  <h3 className="job-title">{job.name}</h3>
                  <p className="job-location">{job.place}</p>
                  <p className="job-type">{job.type}</p>
                  <p className="job-date">Applied: {job.appliedAt}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Applied;